<template>
    <div style="padding-top: 65px;height: 100vh">
        <el-row style="height: 100vh">
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="border"  style="background-color:rgb(230,230,219);z-index: 888;">


                <h1 style="text-align: center">填料部分图</h1>

                <el-carousel height="90vh" style="margin-top: 10vh">
                    <el-carousel-item v-for="item in list" :key="item">
                        <img :src="item.url" alt="" style="width: 100%">
                    </el-carousel-item>
                </el-carousel>



            </el-col>
            <!--      左边标示图结束-->
            <el-col :span="16" class="border" style="padding: 20px;overflow: scroll;height: 100vh">
                <el-form ref="form" :model="form"
 :rules="rules">
                    <h1 style="text-align: center;padding-bottom: 10px">填入毛坯尺寸</h1>

                    <!--                    基础數據-->
                    <div>
                        <h2 style="text-align: center">填入毛坯尺寸</h2>
                        <el-row>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="A" prop="a">
                                    <el-input   type="number" v-model="form.a" placeholder="请输入數據A(单位：mm)"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="B" prop="b">
                                    <el-input  type="number" v-model="form.b" placeholder="请输入數據B(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="C" prop="c">
                                    <el-input  type="number" v-model="form.c" placeholder="请输入數據C(单位：mm)" />
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="D" prop="d">
                                    <el-input  type="number" v-model="form.d" placeholder="请输入數據D(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="E" prop="e">
                                    <el-input  type="number" v-model="form.e" placeholder="请输入數據E(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="F" prop="f">
                                    <el-input  type="number" v-model="form.f" placeholder="请输入數據F(单位：mm)" />
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="G" prop="g">
                                    <el-input  type="number" v-model="form.g" placeholder="请输入數據G(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="H" prop="h">
                                    <el-input  type="number" v-model="form.h" placeholder="请输入數據H(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="I" prop="i">
                                    <el-input  type="number" v-model="form.i" placeholder="请输入數據I(单位：mm)" />
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="J" prop="j">
                                    <el-input  type="number" v-model="form.j" placeholder="请输入數據J(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R1" prop="r1">
                                    <el-input  type="number"  v-model="form.r1" placeholder="请输入圓角1數據(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R2" prop="r2">
                                    <el-input  type="number"  v-model="form.r2" placeholder="请输入圓角2數據(单位：mm)" />
                                </el-form-item>
                            </el-col>


                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R3" prop="r3">
                                    <el-input  type="number" v-model="form.r3" placeholder="请输入圓角3數據(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R4" prop="r4">
                                    <el-input  type="number"  v-model="form.r4" placeholder="请输入圓角4數據(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R5" prop="r5">
                                    <el-input  type="number"  v-model="form.r5" placeholder="请输入圓角5數據(单位：mm)" />
                                </el-form-item>
                            </el-col>


                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R6" prop="r6">
                                    <el-input  type="number" v-model="form.r6" placeholder="请输入圓角6數據(单位：mm)" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="松装密度" prop="density">
                                    <el-input  type="number"  v-model="form.density" placeholder="请输入松装密度(单位：g/cm³)" />
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <!--                        推拔倒角始-->
                        <el-form-item label="推拔倒角">
                            <el-select v-model="form.istuiba" placeholder="请选择有无推拔倒角">
                                <el-option label="无推拔倒角" :value="0"></el-option>
                                <el-option label="自定义推拔倒角" :value="1"></el-option>

                            </el-select>
                        </el-form-item>
                        <el-row v-if="tuiba">
                            <el-col :span="12" >
                                <el-form-item label="推拔倒角长度(T)" prop="i">
                                    <el-input  type="number"  v-model="form.tbTvalue" placeholder="推拔倒角长度(单位:mm)"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                                <el-form-item label="推拔倒角角度(Z)" prop="j">
                                    <el-input  type="number"  v-model="form.tbZvalue" placeholder="推拔倒角角度(单位:度)"  />
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <!--                    推拔倒角末-->

                        <!--                    槽始-->
                        <el-form-item label="槽">
                            <el-select v-model="form.slotting" placeholder="请选择有无槽">
                                <el-option label="无" :value="0"></el-option>
                                <el-option label="有" :value="1"></el-option>

                            </el-select>
                        </el-form-item>
                        <el-row v-if="cao">
                            <el-col :span="12" >
                                <el-form-item label="槽宽(W)" prop="width">
                                    <el-input  type="number"  v-model="form.width" placeholder="槽宽(单位:mm)"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" >
                                <el-form-item label="槽深(S)" prop="thickness">
                                    <el-input  type="number"  v-model="form.thickness" placeholder="槽深(单位:mm)"  />
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <!--                    槽末-->
                    </div>

                    <Ifcoresyapi :formToIfcoresyapi="form"/>



                </el-form>
            </el-col>
        </el-row>

    </div>
</template>

<script>

    import request from "@/utils/request";
    import Ifcoresyapi from "../../components/IfcoresYapi";

    export default {
        name: "PQ",
        components:{
            Ifcoresyapi
        },
        metaInfo: {
            title: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<=0){
                        tip = "值必須大於0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                    let tip = "";

                    if (value * 1 === 0||value * 1<0) {
                        tip = "值必須大於0"
                    }else{

                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            var check2=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "值必須大於等於0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            return{
                list:[{
                    url:require("../../../assets/PQ4.png")
                },
                    {
                        url:require("../../../assets/pq21.png")
                    },
                    {
                        url:require("../../../assets/pq11.png")
                    },
                    {
                        url:require("../../../assets/pq31.png")
                    }],
                dialogVisible: false,//弹出框
                dialogVisible2: false,
                press:false,
                foot:true,
                cao:false,//槽
                tuiba:false,//推拔倒角的输入界面
                loading:false,
                form: {
                    istuiba:0,//是否有推拔倒角
                    slotting:0,//选择有无槽
                    type:"PQ",
                    filetype:1
                },
                rules: {
                    a: [
                        {required: true, message: '數據A是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}

                    ],
                    b: [
                        {required: true, message: '數據B是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}],
                    c: [
                        {required: true, message: '數據C是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}

                    ],
                    d: [
                        {required: true, message: '數據D是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    e: [
                        {required: true, message: '數據E是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    f: [
                        {required: true, message: '數據F是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    g: [
                        {required: true, message: '數據G是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    h: [
                        {required: true, message: '數據H是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    i: [
                        {required: true, message: '數據I是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    j: [
                        {required: true, message: '數據J是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],
                    r1: [
                        {required: true, message: '圓角1是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    r2: [
                        {required: true, message: '圓角2是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    r3: [
                        {required: true, message: '圓角3是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    r4: [
                        {required: true, message: '圓角4是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    r5: [
                        {required: true, message: '圓角5是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    r6: [
                        {required: true, message: '圓角6是必須數據', trigger: 'blur'},
                        {validator: check2, trigger: 'blur'}
                    ],
                    tbTvalue: [
                        {required: true, message: '倒角是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    tbZvalue: [
                        {required: true, message: '倒角角度是必須數據', trigger: 'blur'},
                        // {validator: check, trigger: 'blur'}
                    ],
                    density: [
                        {required: true, message: '密度是必須數據', trigger: 'blur'},
                        {validator: check, trigger: 'blur'}
                    ],


                    product:[{required: true, message: '產品名是必須數據', trigger: 'blur'},{min:0,max:10,message:"请输入产品名",trigger: 'blur'}],
                    company:[{required: true, message: '公司名是必須數據', trigger: 'blur'},{min:0,max:10,message:"请输入公司名",trigger: 'blur'}],
                    email:[{required: true, message: '接收图纸邮箱是必須數據', trigger: 'blur'},{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}]
                }

            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.istuiba==0){
                        this.tuiba=false
                    }else{
                        this.tuiba=true
                    }
                    if(val.slotting!=1){
                        this.cao=false
                    }else{
                        this.cao=true
                    }

                },
                deep:true //true 深度监听
            }
        },
        created() {
        }

    }
</script>

<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }
    /*.border{*/

    /*    margin-top: 60px;*/
    /*    height: calc(100vh - 120px);*/
    /*}*/

    .el-input{
        width: 90%;
    }
    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
    img:hover{
        cursor: pointer;
    }
    .active{
        border: 1px solid orange !important;
    }

</style>